module.exports = __webpack_public_path__ + "media/images/help/delivery/bg-mv-73d6e1ea623906e0a2925817f92a3f34.png";